import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pnk-icon',
  styleUrl: 'pnk-icon.css',
})
export class PnkIcon {
  @Prop({ mutable: true, reflect: true })
  icon: string | null = null;

  @Element()
  host!: HTMLElement;

  render() {
    return <Host class={`pnk-font-icon w-auto h-full pnk-text-inherit pnk-fill-inherit pnk-flex pnk-justify-center pnk-items-center ${this.icon || ''}`}></Host>;
  }
}
